export default __webpack_public_path__ + "static/media/banner-image-2.ef7aa6ae.jpg";